import React from "react";
import EasasGlobalAlerts from "./EasasGlobalAlerts";

export default function EasasGlobalFragment() {
    return <React.Fragment>
        <EasasGlobalAlerts/>
    </React.Fragment>
}